import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateUtils } from 'src/app/_commons/date-utils';
import { LaResults } from 'src/app/_models/laResults';
import { TopologyList, TopologyWithRoot } from 'src/app/_models/topology-list';
import { ApplicationsResultsService } from 'src/app/_services/applications-results-service/applications-results.service';
import { CommunicationService } from 'src/app/_services/communication-service/communication.service';

@Component({
  selector: 'app-la-overview',
  templateUrl: './la-overview.component.html',
  styleUrls: ['./la-overview.component.css']
})
export class LaOverviewComponent implements OnInit {

  constructor(
    private applicationsResultsService: ApplicationsResultsService,
    public translate: TranslateService,
    private communicationService: CommunicationService
  ) {
    const lang = localStorage.getItem('Language')
    this.translate.use(lang);
  }

  public isSidebarOpen: boolean;
  public topologies: TopologyList;
  public selectTopologyMap: Map<string, string> = new Map<string, string>();
  laResults: Array<LaResults> = new Array<LaResults>();

  public selectedTopology: string;

  isSearching: boolean[] = Array(8).fill(false);
  searchText: string[] = Array(8).fill('');

  @ViewChild('searchInput', { static: false}) searchInputRef! : ElementRef;
  private shouldFocusInput = false;

  ngOnInit() {

    this.topologies = JSON.parse(localStorage.getItem("topologies"));
    this.loadTopologies();
    console.log('Topology Map:', this.selectTopologyMap);
    const selectedTopology = JSON.parse(localStorage.getItem('currentTopology'));

    this.applicationsResultsService.setSidebarOpen(true);
    console.log('Sidebar Open:', this.applicationsResultsService.getSidebarOpen());
    this.isSidebarOpen = this.applicationsResultsService.getSidebarOpen();


    this.loadLaResults(selectedTopology.topologyId);
  }

  loadTopologies(){
    this.topologies.topologiesWithRoots.forEach((TopologyWithRoot: TopologyWithRoot) => {
      this.selectTopologyMap.set(TopologyWithRoot.displayName || TopologyWithRoot.internalDsoId + " - "  + TopologyWithRoot.TopologyId, TopologyWithRoot.TopologyId );
    });

    this.selectTopologyMap.forEach((value, key) => {
      if (key === this.topologies.topologiesWithRoots[0].displayName || key === this.topologies.topologiesWithRoots[0].internalDsoId + " - "  + this.topologies.topologiesWithRoots[0].TopologyId) {
        this.selectedTopology = key;
      }
    });

    console.log("Selected Topology: ", this.selectedTopology);
  }

  loadLaResults(value: string){
    this.applicationsResultsService.getLaResults(this.selectTopologyMap.get(value) || value).subscribe((data) => {

      this.laResults = (data || []).filter(item => item).map(item => new LaResults(
        item.gridElement_id || "N/A",
        item.dso_internal_id || "N/A",
        item.type || "N/A",
        item.maxLoad || 0.00,
        item.maxLoadTimestamp ? DateUtils.stringUTCDateToLocalDate(item.maxLoadTimestamp) : "N/A",
        item.maxCurrent || 0.00,
        item.maxApparentPower || 0.00,
        item.numberOfViolation || 0.00
      ));
      console.log("La results: ", this.laResults);
      
      // console.log("La reulsts: ", data);
    });
  }

  getTopologiesDisplayNameForSelectField(): string[] {
    return Array.from(this.selectTopologyMap.keys());
  }

  sortTable(columnIndex: number): void {
    const table = document.getElementById("sortableTable");
    if (!table) return;
  
    const rows = Array.from((table as HTMLTableElement).rows).slice(1); // Skip header
    let isAscending = table.getAttribute("data-sort-order") === "asc";
  
    const parseDateToTimestamp = (value: string): number => {
      const trimmed = value.trim();
      const date = new Date(trimmed);
      return isNaN(date.getTime()) ? Infinity : date.getTime();
    };
  
    const sampleSize = Math.min(5, rows.length);
    const isDate = rows.slice(0, sampleSize).some(row => {
      const value = row.cells[columnIndex].innerText.trim();
      if (
        value === '' ||
        value.toLowerCase() === 'n/a' ||
        !/[\/\-:,]/.test(value)
      ) {
        return false;
      }
      const date = new Date(value);
      return !isNaN(date.getTime());
    });
    const isNumeric = rows.some(row => {
      const value = row.cells[columnIndex].innerText.trim();
      return !isNaN(parseFloat(value)) && value !== '' && value !== 'N/A' && value !== 'n/a';
    });
  
    rows.sort((rowA, rowB) => {
      const cellA = rowA.cells[columnIndex].innerText.trim() || '';
      const cellB = rowB.cells[columnIndex].innerText.trim() || '';

      if (isDate) {
        const dateA = parseDateToTimestamp(cellA);
        const dateB = parseDateToTimestamp(cellB);
        // console.log("Date sorting");
        return isAscending ? dateA - dateB : dateB - dateA;
      }

      
      if (isNumeric) {
        const numbA = (cellA === 'N/A' || cellA === '' || isNaN(parseFloat(cellA))) ? Infinity : parseFloat(cellA);
        const numbB = (cellB === 'N/A' || cellB === '' || isNaN(parseFloat(cellB))) ? Infinity : parseFloat(cellB);
  
        // console.error("Numeric sorting");
        return isAscending ? numbA - numbB : numbB - numbA;
      } 
  
      return isAscending ? cellA.localeCompare(cellB) : cellB.localeCompare(cellA);
    });
    table.setAttribute("data-sort-order", isAscending ? "desc" : "asc");
    rows.forEach(row => table.appendChild(row));
  }

  toggleSearch(index: number): void {
    // Мне нужнно сделать так, чтобы при нажатии на кнопку поиска, она меняла свое состояния 
    // при этому все остальные кнопки поиска меняли свое состояние на false
    // И каждый раз при нажатии все searchText[index] менялись на пустую строку
    // this.isSearching.forEach((_, i))
    this.isSearching = this.isSearching.map((_, i) => i === index ? !this.isSearching[i] : false);

    if(this.isSearching.every(value => value === false)){
      this.searchText = Array(8).fill('');
    }
    console.log("Search Toggled:", this.isSearching);

    if(this.isSearching[index]){
      this.shouldFocusInput = true;
    }
  }

  ngAfterViewChecked(){
    if(this.shouldFocusInput && this.searchInputRef){
      this.searchInputRef.nativeElement.focus();
      this.shouldFocusInput = false;
    }
  }

  filteredLaResults(): any[] {
    
    if(this.isSearching.every(value => value === false)){
      this.searchText = Array(8).fill('');
    }
    if(this.searchText.every(text => !text)){
      return this.laResults;
    }

    return this.laResults.filter(item => {
      return this.searchText.every((text, index) => {
        if(!text) return true;
        const value = Object.values(item)[index];
        return value.toString().toLowerCase().includes(text.toLowerCase())
      })
    })
  }
  
  openInput(){
    console.log('openInput');
  }

  getViolationColoring(laResult: LaResults): string{
    if(laResult.numberOfViolations > 0){
      return 'red';
    }
  }

  resetDefaultTopology(){
    this.communicationService.setTopologyId(null);
  }
}
